export enum OptionVisibility {
    Disabled,
    Hidden
}
